import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';
import { Button } from '../button/button.js';

var _excluded = ["icon", "inline", "text", "tooltipProps", "buttonRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var IconOnlyButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var IconIncoming = _ref.icon;
      _ref.inline;
      var text = _ref.text,
      tooltipProps = _ref.tooltipProps,
      buttonRef = _ref.buttonRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var combinedProps = _objectSpread(_objectSpread({}, props), {}, {
    icon: IconIncoming,
    "aria-label": text
  });

  return /*#__PURE__*/React__default.createElement(TooltipV2, _extends({
    content: text
  }, tooltipProps, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(Button, _extends({
    ref: buttonRef
  }, combinedProps)));
});

export { IconOnlyButton };
//# sourceMappingURL=icon-only-button.js.map
